import router from '@/router.js'

export default {
    MEETING(state, response) {
        if(response.status == 200) {
            state.meeting = response.data.meeting;
        }
    },
    JOIN(state, response) {
        if(response.status == 200) {
            localStorage.setItem('token', response.data.authToken);
            localStorage.setItem('role', response.data.role);

            state.meeting = response.data.meeting;
            state.otherUser = response.data.otherUser;
            state.twilioToken = response.data.twilioToken;

            state.canReview = response.data.canReview;
        } else {
            localStorage.removeItem('roomAccessToken');
            var token = localStorage.getItem('token');
            var role = localStorage.getItem('role');

            if(token && role)
                router.push('/'+role+'/appointments');
            else
                router.push('/login');
        }
    },
    SEND_TIP_TO_SPECIALIST(state, response) {
        state.tipsThankyou = true;
        setTimeout(() => {
            router.push('/client/appointments');
        }, 3000);
    },
    FINISH(state) {
        state.meeting = {};
        state.twilioToken = null;
        state.otherUser = {};
        state.feedbackModal = {
            active: false
        };
        // state.status = null;
        state.canReview = false;
        state.tipsThankyou = false;
    },
}
